import { getServerContext } from "../getServerState";
import { onDestroy } from "svelte";
export function onDestroyClientSide(callback) {
    const serverContext = getServerContext();
    if (!serverContext) {
        onDestroy(callback);
    }
}
